import React from "react";
import { Stack } from "@mui/system";
import { Helmet } from "react-helmet-async";

import TitleProject from "../Components/Title";
import Ouvidoria from "../../../components/Ouvidoria";

import './style.scss';
import Galery from "./galery";


export default function SossegoVale(){

  return(

    <>
    <Helmet title="Projeto Sossego - Séculos Engenharia e Serviços LTDA" />
    <TitleProject name="PROJETO SOSSEGO" link1={"Projetos/ "} link2={"PROJETO SOSSEGO"} />
      <section id="context">
        <div className="container">

        <div>
          <Stack
            direction={{xs: 'column', sm: 'row'}}
            spacing={{xs: 1, sm: 2, md: 4}}
            className="context-desc"
          >
            <div className="context-box">
              <div className="context-desc-inside">
                <h2
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">Projeto Sossego</h2>
                <p
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">Prestação de serviços de limpeza, eletromecânicos, obras civis de pequeno porte e locação de equipamentos de pequeno porte para Mina do Sossego da VALE, em Canaã dos Carajás – PA.
                </p>
              </div>
            </div>

            <div className="context-box context-info">
                <h2
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">Informações do Projeto</h2>
                <ul
                  data-aos="fade-zoom-in" 
                  data-aos-duration="1000"
                  data-aos-delay="300"
                  data-aos-offse="0">
                  <li><strong>Cliente: </strong> Vale</li>
                  <li><strong>Cidade: </strong> Canaã dos Carajás - PA </li>
                  <li><strong>Ano: </strong> 2021 </li>
                  <li><strong>Segmento: </strong> Facilities </li>
                </ul>
            </div>

          </Stack>
        </div>
        </div>
      </section>

      <Galery />
      <Ouvidoria/>
    </>
  );
};